module.exports = __webpack_public_path__ + "img/small-logo-on-white.2c92b7bf.png";